<template>
  <div class="head-page">
    <Header :title="$t('loans.Application')" />
    <div class="head-page-overflow" style="padding-bottom: 50px">
      <div class="loan-area">
        <div class="title-box">
          <div class="icon"><img src="../../assets//logod.png" /></div>
          <div class="title">{{ itemdata.title }}</div>
        </div>
      </div>
      <div class="loan-area">
        <p class="desc">
          {{ $t("loans.Institution") }} :
          {{ itemdata.mechanism }}
        </p>
        <p class="desc">
          {{ $t("loans.DailyInterest") }} : {{ itemdata.interest_rate }} %
        </p>
        <p class="desc">
          {{ $t("loans.RepaymentPeriod") }} : {{ itemdata.cycle }}
          {{ $t("common.day") }}
        </p>
        <p class="desc">
          {{ $t("loans.Amount") }} : {{ itemdata.minprice }} -
          {{ itemdata.maxprice }}
        </p>
        <van-cell
          :title="$t('loans.RepaymentMethod')"
          :value="$t('loans.Onetime')"
        />
        <van-cell :title="$t('loans.Expected_loan_amount')">
          <template #default>
            <van-stepper
              v-model="frm.amount"
              :min="itemdata.minprice"
              :max="itemdata.maxprice"
              theme="round"
              integer
              input-width="80px"
              button-size="32px"
            />
          </template>
        </van-cell>
      </div>
      <div class="loan-area">
        <div class="frm-title">
          {{ $t("loans.imgplaceholdr") }}
        </div>
        <van-row class="txt-center">
          <van-col :span="8">
            <van-uploader
              v-model="uploader1"
              :max-count="1"
              :after-read="File1AferReade1"
              :before-delete="file1Delete1"
            />
            <p>{{ $t("loans.icon1") }}</p>
          </van-col>
          <van-col :span="8">
            <van-uploader
              v-model="uploader2"
              :max-count="1"
              :after-read="File1AferReade2"
              :before-delete="file1Delete2"
            />
            <p>{{ $t("loans.icon2") }}</p>
          </van-col>
          <van-col :span="8">
            <van-uploader
              v-model="uploader3"
              :max-count="1"
              :after-read="File1AferReade3"
              :before-delete="file1Delete3"
            />
            <p>{{ $t("loans.icon3") }}</p>
          </van-col>
        </van-row>
      </div>
    </div>
    <LoanFoot
      :money="frm.amount"
      :posting="posting"
      :btnName="$t('loans.Application')"
      @page-submit="toSub"
    />
  </div>
</template>

<script>
import Header from "@/components/Header";
import { LoanFoot } from "./components/index";
import { getToken, getTokenbyName, TokenLangKey } from "@/utils/cookies";
import Axios from "axios";
export default {
  name: "LoanApplication",
  components: { Header, LoanFoot },
  data() {
    return {
      loanid: null,
      itemdata: {},
      uploader1: [],
      uploader2: [],
      uploader3: [],
      posting: false,
      frm: {
        id: null, //	是	int	贷款项目id
        amount: null, //	是	int	申请金额
        front_card: null, //	是	string	身份证正面照
        later_card: null, //	是	string	身份证反面照
        handheld_card: null, //	是	string	手持身份证
      },
    };
  },
  mounted() {
    this.loanid = this.$route.query.id;
    if (this.loanid) {
      this.getData();
    }
  },
  methods: {
    toSub(){
      this.onSubmit()
    },
    async onSubmit() {
      if (
        this.frm.amount < this.itemdata.minprice ||
        this.frm.amount > this.itemdata.maxprice
      ) {
        this.$toast.fail(
          this.$t("loans.Expected_loan_amounterror", {
            min: this.itemdata.minprice,
            max: this.itemdata.maxprice,
          })
        );
        return;
      }
      if (!(this.frm.front_card && this.frm.front_card.length > 0)) {
        this.$toast.fail(this.$t("loans.icon1"));
        return;
      }
      if (!(this.frm.later_card && this.frm.later_card.length > 0)) {
        this.$toast.fail(this.$t("loans.icon2"));
        return;
      }
      if (!(this.frm.handheld_card && this.frm.handheld_card.length > 0)) {
        this.$toast.fail(this.$t("loans.icon3"));
        return;
      }

      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "applyLoan",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.file1Delete1()
          this.file1Delete2()
          this.file1Delete3()
        })
        .catch(() => {
          this.posting = false;
        });
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getLoanProjects",
        data: { id: this.loanid },
      }).then((res) => {
        this.itemdata = res.data.list[0];
        if (this.itemdata) {
          this.frm.amount = this.itemdata.minprice;
          this.frm.id = this.itemdata.id
        }
      });
    },
    async fileUpload(file, type) {
      file.status = "uploading";
      const formData = new FormData();
      formData.append("file", file.file);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Token: getToken(),
          Lang: getTokenbyName(TokenLangKey),
        },
      };
      await Axios.post("/api/api/common/upload", formData, config)
        .then((response) => {
          file.status = "";
          if (type == 1) {
            this.frm.front_card = response.data.data.url;
          }
          if (type == 2) {
            this.frm.later_card = response.data.data.url;
          }
          if (type == 3) {
            this.frm.handheld_card = response.data.data.url;
          }
        })
        .catch((error) => {
          file.status = "failed";
          console.log(error);
        });
    },
    File1AferReade1(file) {
      this.fileUpload(file, 1);
    },
    File1AferReade2(file) {
      this.fileUpload(file, 2);
    },
    File1AferReade3(file) {
      this.fileUpload(file, 3);
    },
    file1Delete1() {
      this.frm.front_card = null;
      this.uploader1 = [];
    },
    file1Delete2() {
      this.frm.later_card = null;
      this.uploader2 = [];
    },
    file1Delete3() {
      this.frm.handheld_card = null;
      this.uploader3 = [];
    },
  },
};
</script>

<style>
</style>
